import React from "react";
import {
  Stack,
  Typography,
  Card,
  Tooltip,
  Icon,
  IconButton,
  Alert,
} from "investira.react.components";
import { formats, validators } from "investira.sdk";

const Highlights = (props) => {
  const { data } = props;
  return (
    <>
      <Stack
        direction="column"
        sx={{ gap: 1 }}
        component="section"
        flexGrow={1}
      >
        <Stack gap={1} flexGrow={1} direction={{ xs: "column", md: "row" }}>
          <Card
            sx={{
              flex: 1,
              display: "flex",
              minHeight: 0,
            }}
          >
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Total Financeiro
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>
                      {formats.formatNumber(
                        data.response?.resumo.total_financeiro || 0,
                        2,
                        true,
                        true
                      )}
                    </b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
          <Card sx={{ flex: 1, display: "flex", minHeight: 0 }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Duration Anos
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>
                      {formats.formatNumber(
                        data.response?.resumo.prazo_medio || 0,
                        5,
                        true
                      )}
                    </b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
        <Stack gap={1} flexGrow={1} direction={{ xs: "column", md: "row" }}>
          <Card sx={{ flex: 1, display: "flex", minHeight: 0 }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Convexidade
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>
                      {formats.formatNumber(
                        data.response?.resumo.convexidade || 0,
                        6,
                        true
                      )}
                    </b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
          <Card
            sx={{
              flex: 1,
              display: "flex",
              minHeight: 0,
            }}
          >
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Sensibilidade (Convexidade)
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>
                      {formats.formatNumber(
                        data.response.resumo.convexidade_sensibilidade || 0,
                        6,
                        true,
                        false
                      )}
                      %
                    </b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
        <Stack gap={1} flexGrow={1} direction={{ xs: "column", md: "row" }}>
          <Card
            sx={{
              flex: 1,
              display: "flex",
              minHeight: 0,
            }}
          >
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Duration Modificada
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>
                      {formats.formatNumber(
                        data.response?.resumo.duration_modificada || 0,
                        6,
                        true
                      )}
                    </b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
          <Card sx={{ flex: 1, display: "flex", minHeight: 0 }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Sensibilidade (Dur. Modificada)
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>
                      {formats.formatNumber(
                        data.response?.resumo
                          .duration_modificada_sensibilidade || 0,
                        6,
                        true
                      )}
                      %
                    </b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
        <Stack gap={1} flexGrow={1} direction={{ xs: "column", md: "row" }}>
          <Card
            sx={{
              flex: 1,
              display: "flex",
              minHeight: 0,
            }}
          >
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Ativos Analisados
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>
                      {
                        data.response?.resumo.estatisticas
                          .quantidade_ativos_analisados
                      }
                    </b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
          <Card sx={{ flex: 1, display: "flex", minHeight: 0 }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Fundos Abertos
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>
                      {
                        data.response?.resumo.estatisticas
                          .quantidade_fundos_abertos
                      }
                    </b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
      </Stack>
    </>
  );
};

export default Highlights;
